import React, { useState } from "react";
import button from '../img/button.png';

const ContactForm = () => {
  const [status, setStatus] = useState("Submit");
  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Sending...");
    const { name, email, message } = e.target.elements;
    let details = {
      name: name.value,
      email: email.value,
      message: message.value,
    };
    try {
      let response = await fetch("https://pixelbear.studio/contact", {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=utf-8",
        },
        body: JSON.stringify(details),
      });
      let result = await response.json();
      alert(result.status);
    } catch (err) {
      alert("Sorry, that didn't send. Please try again.");
    } finally {
      setStatus("Submit");
    }
  };

  return (
    <form className="pb-form" onSubmit={handleSubmit}>
      <div className="pb-form-heading">
        <p className="pb-form-kicker">FORM / 001</p>
        <h3>Start a conversation</h3>
      </div>

      <div className="pb-form-row">
        <label className="pb-field">
          <span>Name</span>
          <input type="text" id="name" placeholder="Your name" required />
        </label>
        <label className="pb-field">
          <span>Email</span>
          <input type="email" id="email" placeholder="you@example.com" required />
        </label>
      </div>

      <label className="pb-field">
        <span>Message</span>
        <textarea id="message" placeholder="Tell me a little about your project..." required />
      </label>

      <div className="pb-form-footer">
        <button
          className="pb-button"
          style={{ backgroundImage: `url(${button})` }}
          type="submit"
          disabled={status !== "Submit"}
        >
          {status}
        </button>
      </div>
    </form>
  );
};

export default ContactForm;
